import { render, staticRenderFns } from "./LabValueField.vue?vue&type=template&id=5d452fa5&scoped=true"
import script from "./LabValueField.vue?vue&type=script&lang=ts"
export * from "./LabValueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d452fa5",
  null
  
)

export default component.exports